import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Observable } from 'rxjs'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Permissions } from 'src/app/core/enums/permissions.enum'

@Component({
  selector: 'app-customer-data-layer-config',
  templateUrl: './customer-data-layer-config.component.html',
  styleUrls: ['./customer-data-layer-config.component.scss'],
  standalone: false,
})
export class CustomerDataLayerConfigComponent {
  @Output() closed = new EventEmitter<void>()
  @Input() isLayerSelectionVisible: boolean = false
  Permissions = Permissions
  public isCollapsed = true
  public isInCSFilterMode = false
  private readonly isInCSPropertyFilterKey = 'isInCS'

  constructor(private appState: AppStateService) {
    this.isInCSFilterMode =
      this.appState.selectPropertyFilters()[this.isInCSPropertyFilterKey] === 'true'
  }

  toggleLayerSwitchVisibility() {
    this.isLayerSelectionVisible = !this.isLayerSelectionVisible
  }

  public close() {
    this.isLayerSelectionVisible = false
  }

  public toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed
  }

  public toggleIsInCSFilter(): void {
    this.isInCSFilterMode = !this.isInCSFilterMode

    const propertyFilters = this.appState.selectPropertyFilters()
    if (this.isInCSFilterMode) {
      propertyFilters[this.isInCSPropertyFilterKey] = 'true'
    } else {
      delete propertyFilters[this.isInCSPropertyFilterKey]
    }

    const propertyFiltersSerialized = Object.entries(propertyFilters)
      .map(([key, value]) => `${key}=${value}`)
      .join(',')

    this.appState.setState(AppPaths.Customer, {
      propertyFilters: propertyFiltersSerialized || undefined,
    })
  }
}
